import { Component } from 'react'
import PT from 'prop-types'
import { computed, observable } from 'mobx'

import {
  userCanManageUsers,
  userCanManageVehicles,
  userCanAccessFleet,
} from '#utils/permissions'


const safelyCheckUserPermission = (f, userinfo, domainName) => {
  if (userinfo.id === null) {
    return false
  }
  return f(userinfo, domainName)
}

class PermissionsProvider extends Component {
  getChildContext() {
    const { domain, userinfo } = this.context

    const permissions = observable({
      userCanManageVehicles: computed(() =>
        safelyCheckUserPermission(userCanManageVehicles, userinfo, domain.name),
      ),
      userCanManageUsers: computed(() =>
        safelyCheckUserPermission(userCanManageUsers, userinfo, domain.name),
      ),
      userCanAccessFleet: computed(() =>
        safelyCheckUserPermission(userCanAccessFleet, userinfo, domain.name),
      ),
    })

    return { permissions }
  }

  render() {
    return this.props.children
  }
}

PermissionsProvider.contextTypes = {
  domain: PT.object.isRequired,
  userinfo: PT.object.isRequired,
}

PermissionsProvider.childContextTypes = {
  permissions: PT.object,
}

PermissionsProvider.propTypes = {
  children: PT.node,
}

export default PermissionsProvider
